<template>
  <v-dialog v-model="show" persistent max-width="60%">
    <Card>
      <v-card-text style="max-height: 80vh; overflow-y: auto;">
        <v-row>
          <v-col cols="12" md="10">
            <span class="titulo-header">Buscar por</span>
          </v-col>
        </v-row>

        <v-form ref="form" v-model="isFormValid" lazy-validation>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-select
                label="Tipo de búsqueda"
                :items="tiposBusqueda"
                v-model="form.tipoBusqueda"
                outlined
                color="#b11f1f"
                :no-data-text="'No se encontraron resultados...'"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                label="Producto"
                :items="productosAseguradora"
                v-model="form.producto_aseguradora"
                outlined
                color="#b11f1f"
                :no-data-text="'No se encontraron resultados...'"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.tarjeta"
                label="Tarjeta"
                outlined
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.nombre"
                label="Nombre"
                outlined
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.apellidoPaterno"
                label="Apellido Paterno"
                outlined
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.apellidoMaterno"
                label="Apellido Materno"
                outlined
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.rfc"
                label="RFC"
                outlined
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.celular"
                label="Teléfono"
                outlined
                prepend-inner-icon="mdi-phone"
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.email"
                label="Correo electrónico"
                outlined
                prepend-inner-icon="mdi-email"
                color="#b11f1f"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.poliza"
                label="Póliza"
                outlined
                color="#b11f1f"
              />
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12" md="4" class="d-flex justify-end">
              <v-btn
                dark
                outlined
                color="#b11f1f"
                rounded
                class="mr-2"
                min-width="120"
                @click="clearForm()"
              >
                Limpiar
              </v-btn>
              <v-btn
                class="common-botton"
                dark
                min-width="120"
                :disabled="!isFormValid || sinTipo"
                :loading="loading"
                @click="buscar(true)"
              >
                Filtrar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

        <!-- TABLA DE RESULTADOS -->
        <div class="pt-5">
          <v-data-table
            :items="registros"
            :headers="headers"
            :loading="loading"
            :server-items-length="totalItems"
            :items-per-page="pagination.itemsPerPage"
            :page="pagination.page"
            no-data-text="Sin registros para mostrar"
            no-results-text="Sin resultados para mostrar"
            loading-text="Cargando..."
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-options': [5, 10, 15],
            }"
            @update:page="onPageChange"
            @update:items-per-page="onItemsPerPageChange"
          >
            <template v-slot:top>
              <v-row style="padding: 15px;">
                <v-col cols="12" md="8">
                  <h2>Resultados de la búsqueda</h2>
                </v-col>
              </v-row>
            </template>

            <template #item.ver="{ item }">
              <v-btn icon x-small @click="seleccionar(item)">
                <v-icon color="#b11f1f">mdi-check</v-icon>
              </v-btn>
            </template>

            <template
              v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }"
            >
              <div v-if="itemsLength">
                Mostrando {{ pageStart }} - {{ pageStop }} de
                {{ itemsLength }} resultados
              </div>
            </template>
          </v-data-table>
        </div>
        <v-row class="mt-6" justify="end">
          <v-btn color="#b11f1f" dark rounded min-width="140" @click="cancelar">
            Cancelar
          </v-btn>
        </v-row>
      </v-card-text>
    </Card>
  </v-dialog>
</template>

<script>
import Card from "@/components/commondComponents/Card.vue";
import { getClientesByFiltros } from "@/services/clienteService";
import { getSolicitudesByFilters } from "@/services/solicitudService";
import { getLeadsByFilters } from "@/services/leadService";
import { mainAxios } from "@/mainAxios";

export default {
  components: { Card },
  props: {
    show: Boolean,
    productosAseguradora: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFormValid: false,
      loading: false,
      registros: [],
      totalItems: 0,
      pagination: { page: 1, itemsPerPage: 5 },
      form: {
        tipoBusqueda: null,
        tipo: null,
        tarjeta: null,
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        rfc: null,
        celular: null,
        email: null,
        poliza: null,
      },
      tiposBusqueda: ["Poliza", "Cliente", "Lead", "Solicitud"],
      headers: [
        { text: "ID", value: "id" },
        { text: "Tarjeta / Cuenta", value: "tarjeta" },
        { text: "Cliente / Lead", value: "cliente" },
        { text: "Teléfono", value: "telefono" },
        { text: "Fecha de nacimiento", value: "fechaNacimiento" },
        { text: "Seleccionar", value: "ver" },
      ],
      axiosConfig: {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      },
    };
  },

  computed: {
    sinTipo() {
      const f = this.form;
      return (
        !f.tipoBusqueda || f.tipoBusqueda === ""
      );
    },
  },
  watch: {
    "form.tipoBusqueda"() {
      this.pagination.page = 1;
      this.totalItems = 0;
      this.registros = [];
    },
  },

  methods: {
    cancelar() {
      this.form = {};
      this.registros = [];
      this.$emit("onCancel");
    },
    buildRequestBody(tipoBusqueda) {
      // Filtrar valores nulos, undefined y vacíos
      const filtrosLimpios = Object.fromEntries(
        Object.entries(this.form).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );

      // Construir body específico según el tipo de búsqueda
      if (tipoBusqueda === "Poliza") {
        const body = { ...filtrosLimpios };
        if (body.celular) {
          body.telefono = body.celular;
          delete body.celular;
        }
        if (body.email) {
          body.correo = body.email;
          delete body.email;
        }
        delete body.tipoBusqueda;
        return body;
      }

      if (tipoBusqueda === "Cliente") {
        const body = { ...filtrosLimpios };
        if (body.apellidoPaterno) {
          body.apellido_paterno = body.apellidoPaterno;
          delete body.apellidoPaterno;
        }
        if (body.apellidoMaterno) {
          body.apellido_materno = body.apellidoMaterno;
          delete body.apellidoMaterno;
        }
        if (body.email) {
          body.correo = body.email;
          delete body.email;
        }
        if (body.celular) {
          body.telefono_movil = body.celular;
          delete body.celular;
        }
        if (body.tarjeta) {
          body.cuenta = body.tarjeta;
          delete body.tarjeta;
        }
        delete body.tipoBusqueda;
        return body;
      }

      if (tipoBusqueda === "Solicitud") {
        const body = { ...filtrosLimpios };
        if (body.apellidoPaterno) {
          body.apellido_paterno = body.apellidoPaterno;
          delete body.apellidoPaterno;
        }
        if (body.apellidoMaterno) {
          body.apellido_materno = body.apellidoMaterno;
          delete body.apellidoMaterno;
        }
        if (body.email) {
          body.correo_electronico = body.email;
          delete body.email;
        }
        if (body.poliza) {
          body.certificado = body.poliza;
          delete body.poliza;
        }
        delete body.tipoBusqueda;
        return body;
      }

      if (tipoBusqueda === "Lead") {
        const body = { ...filtrosLimpios };
        if (body.apellidoPaterno) {
          body.apellido_paterno = body.apellidoPaterno;
          delete body.apellidoPaterno;
        }
        if (body.apellidoMaterno) {
          body.apellido_materno = body.apellidoMaterno;
          delete body.apellidoMaterno;
        }
        if (body.email) {
          body.correo = body.email;
          delete body.email;
        }
        if (body.celular) {
          body.telefono = body.celular;
          delete body.celular;
        }
        if (body.tarjeta) {
          body.cuenta = body.tarjeta;
          delete body.tarjeta;
        }
        delete body.tipoBusqueda;
        return body;
      }

      const body = { ...filtrosLimpios };
      delete body.tipoBusqueda;
      return body;
    },
    async buscar(resetPage = false) {
      if (resetPage) {
        this.pagination.page = 1;
      }
      this.loading = true;
      this.totalItems = 0;
      try {
        const body = this.buildRequestBody(this.form.tipoBusqueda);

        if (this.form.tipoBusqueda === "Poliza") {
          body.pagina = this.pagination.page;
          body.elementosPagina = this.pagination.itemsPerPage;
          const { data } = await mainAxios.post(
            "/v1/emision/list/filtros",
            body,
            this.axiosConfig
          );
          this.registros = (data?.emisiones || []).map((item) => ({
            id: item.id,
            tarjeta: item.poliza,
            cliente: item.nombreCliente || item.titular,
            telefono: item.telefono || item.telefonoContacto,
            fechaNacimiento: item.fechaNacimiento,
            ver: "ver",
            raw: item,
          }));
          this.totalItems = data?.totalRegistros || 0;
        } else if (this.form.tipoBusqueda === "Cliente") {
          body.pagina = this.pagination.page;
          body.elementosPagina = this.pagination.itemsPerPage;

          const data = await getClientesByFiltros(body);
          this.registros = (data.clientes || []).map((cli) => ({
            id: cli.id,
            tarjeta: cli.correo,
            cliente: `${cli.nombre || ""} ${cli.apellidoPaterno ||
              ""} ${cli.apellidoMaterno || ""}`.trim(),
            telefono:
              cli.telefonoMovil || cli.telefonoContacto || cli.telefonoOficina,
            fechaNacimiento: cli.fechaNacimiento,
            ver: "ver",
            raw: cli,
          }));
          this.totalItems = this.registros.length;
        } else if (this.form.tipoBusqueda === "Lead") {
          body.page = this.pagination.page;
          body.size = this.pagination.itemsPerPage;

          const data = await getLeadsByFilters(body);

          this.registros = (data.leads || []).map((lead) => ({
            id: lead.id,
            tarjeta: lead.id_bradescard,
            cliente: lead.nombre,
            telefono: lead.telefono,
            fechaNacimiento: lead.fecha_nacimiento,
            ver: "ver",
            raw: lead,
          }));

          this.totalItems = data.numRegisters;
        } else if (this.form.tipoBusqueda === "Solicitud") {
          body.pagina = this.pagination.page;
          body.registrosPagina = this.pagination.itemsPerPage;
          const data = await getSolicitudesByFilters(body);

          this.registros = (data.solicitudes || []).map((soli) => ({
            id: soli.id,
            tarjeta: soli.tarjeta,
            cliente: `${soli.nombre || ""} ${soli.apellidoPaterno ||
              ""} ${soli.apellidoMaterno || ""}`.trim(),
            telefono: soli.celular,
            fechaNacimiento: soli.fechaNacimiento,
            ver: "ver",
            raw: soli,
          }));

          this.totalItems = data.totalRegistros;
        }
      } catch (error) {
        this.registros = [];
        console.error("Error al filtrar:", error);
      } finally {
        this.loading = false;
      }
    },
    seleccionar(item) {
      this.$emit("selected", item, this.form.tipoBusqueda);
    },
    onPageChange(newPage) {
      this.pagination.page = newPage;
      if (this.form.tipoBusqueda) {
        this.buscar();
      }
    },
    onItemsPerPageChange(newSize) {
      this.pagination.itemsPerPage = newSize;
      this.pagination.page = 1;
      if (this.form.tipoBusqueda) {
        this.buscar();
      }
    },
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
    },
  },
};
</script>

<style scoped>
.titulo-header {
  font-weight: 700;
  font-size: 26px;
  color: #741919;
}

.theme--light.v-data-table {
  background-color: #fcf2f2;
  border-radius: 20px;
}
</style>
